import { useFormContext, useFieldArray, useWatch } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { SlotDate } from "../slot-date";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useDeleteAvailability } from "../../api/delete-availability";
import { SlotTime } from "../slot-time";

export const ExceptionSlots = ({ day }) => {
    const { control, setValue, clearErrors } = useFormContext();

    const allDay = useWatch({
        control,
        name: `${day}.Dates[0].allDay`,
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: `${day}.Times`,
    });

    const addSlot = () => {
        append({
            availabilityGuid: "",
            startTime: "",
            endTime: "",
        });
    };

    const mutation = useDeleteAvailability();

    const onRemove = (index, availabilityGuid, startTime, endTime) => {
        const removeSlot = () => {
            remove(index);

            if (fields.length === 1) {
                setValue(`${day}.Dates[0].allDay`, true);
                clearErrors(`${day}.Times`);
            }
        };

        const isRealAvailability =
            availabilityGuid && !(startTime === "" && endTime === "");

        if (isRealAvailability) {
            mutation.mutate(availabilityGuid, {
                onSuccess: removeSlot,
            });
        } else {
            if (fields.length === 1) {
                setValue(`${day}.Dates[0].allDay`, true);
                clearErrors(`${day}.Times`);
            } else {
                removeSlot();
            }
        }
    };

    return (
        <div className="relative -mx-1 space-y-2 overflow-x-auto">
            <table className="w-full max-w-100 table-fixed text-left">
                <thead>
                    <tr>
                        <th
                            scope="col"
                            className="w-[40%] px-1 font-medium md:w-[39%]"
                        >
                            Start date
                        </th>
                        <th
                            scope="col"
                            className="w-[40%] px-1 font-medium md:w-[39%]"
                        >
                            End date
                        </th>
                        <th
                            scope="col"
                            className="w-[18%] px-2 font-medium md:w-[22%]"
                        >
                            All day
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="align-top">
                        <SlotDate day={day} />
                    </tr>
                </tbody>
            </table>
            {!allDay && (
                <>
                    <table className="w-full max-w-100 table-fixed text-left">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    className="w-[40%] px-1 font-medium md:w-[39%]"
                                >
                                    Start time
                                </th>
                                <th
                                    scope="col"
                                    className="w-[40%] px-1 font-medium md:w-[39%]"
                                >
                                    End time
                                </th>
                                <th
                                    scope="col"
                                    className="w-[18%] px-1 font-medium md:w-[22%]"
                                ></th>
                            </tr>
                        </thead>
                        <tbody>
                            {fields.map((field, index) => (
                                <tr key={field.id} className="align-top">
                                    <SlotTime
                                        day={day}
                                        index={index}
                                        onRemove={onRemove}
                                        availabilityGuid={
                                            field.availabilityGuid
                                        }
                                    />
                                </tr>
                            ))}
                            <tr>
                                <td className="px-1 py-2">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        onClick={addSlot}
                                    >
                                        <PlusIcon />
                                        Add another time slot
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="mt-3 px-1">
                        <p className="mb-2 text-sm text-neutral-600">
                            End time = when your last appointment finishes, not
                            when it starts.
                        </p>
                    </div>
                </>
            )}
        </div>
    );
};
